import Vue from 'vue'
import VueRouter from 'vue-router'

import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [{
            path: '/',
            name: 'home',
            component: () =>
                import ('@/views/Home.vue'),
            meta: {
                pageTitle: 'Home',
                breadcrumb: [{
                    text: 'Home',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/prevision',
            name: 'prevision',
            component: () =>
                import ('@/views/PrevisionV2.vue'),
            meta: {
                pageTitle: 'Prevision',
                breadcrumb: [{
                    text: 'Prevision',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/prevision-v1',
            name: 'prevision-v1',
            component: () =>
                import ('@/views/Prevision.vue'),
            meta: {
                pageTitle: 'Prevision v1',
                breadcrumb: [{
                    text: 'Prevision v1',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/marketing',
            name: 'marketing',
            component: () =>
                import ('@/views/Marketing.vue'),
            meta: {
                pageTitle: 'Marketing',
                breadcrumb: [{
                    text: 'Marketing',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/shareasale',
            name: 'shareasale',
            component: () =>
                import ('@/views/marketing/Shareasale.vue'),
            meta: {
                pageTitle: 'Shareasale',
                breadcrumb: [{
                    text: 'Shareasale',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/upload',
            name: 'upload',
            component: () =>
                import ('@/views/Upload.vue'),
            meta: {
                pageTitle: 'Upload',
                breadcrumb: [{
                    text: 'Upload',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/return-reasons',
            name: 'return-reasons',
            component: () =>
                import ('@/views/SkuReturnReasons.vue'),
            meta: {
                pageTitle: 'ReturnReasons',
                breadcrumb: [{
                    text: 'ReturnReasons',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/language',
            name: 'language',
            component: () =>
                import ('@/views/Language.vue'),
            meta: {
                pageTitle: 'Language',
                breadcrumb: [{
                    text: 'Language',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/proveedores',
            name: 'proveedores',
            component: () =>
                import ('@/views/Proveedores.vue'),
            meta: {
                pageTitle: 'Proveedores',
                breadcrumb: [{
                    text: 'Proveedores',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/customers',
            name: 'customers',
            component: () =>
                import ('@/views/Customers.vue'),
            meta: {
                pageTitle: 'Customers',
                breadcrumb: [{
                    text: 'Customers',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/proformas',
            name: 'proformas',
            component: () =>
                import ('@/views/Proformas.vue'),
            meta: {
                pageTitle: 'Proformas',
                breadcrumb: [{
                    text: 'Proformas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/creditos',
            name: 'creditos',
            component: () =>
                import ('@/views/Creditos.vue'),
            meta: {
                pageTitle: 'Créditos',
                breadcrumb: [{
                    text: 'Créditos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/facturas',
            name: 'facturas',
            component: () =>
                import ('@/views/Facturas.vue'),
            meta: {
                pageTitle: 'Facturas',
                breadcrumb: [{
                    text: 'Facturas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/potencial-customers',
            name: 'potencial-customers',
            component: () =>
                import ('@/views/PotencialCustomers.vue'),
            meta: {
                pageTitle: 'Potencial Customers',
                breadcrumb: [{
                    text: 'Potencial Customers',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/customers/:id',
            name: 'customer-profile',
            component: () =>
                import ('@/views/CustomerProfile.vue'),
            meta: {
                pageTitle: 'Perfil de customer',
                breadcrumb: [{
                    text: 'Customers',
                    to: '/customers',
                }, {
                    text: 'Perfil',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/materiales',
            name: 'materiales',
            component: () =>
                import ('@/views/Materiales.vue'),
            meta: {
                pageTitle: 'Materiales',
                breadcrumb: [{
                    text: 'Materiales',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/skumateriales',
            name: 'skumateriales',
            component: () =>
                import ('@/views/SkuMateriales.vue'),
            meta: {
                pageTitle: 'SkuMateriales',
                breadcrumb: [{
                    text: 'SkuMateriales',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/almacen',
            name: 'almacen',
            component: () =>
                import ('@/views/Almacen.vue'),
            meta: {
                pageTitle: 'Almacén RFID',
                breadcrumb: [{
                    text: 'Almacén RFID',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/maquinas',
            name: 'maquinas',
            component: () =>
                import ('@/views/Maquinas.vue'),
            meta: {
                pageTitle: 'Máquinas',
                breadcrumb: [{
                    text: 'Máquinas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/stock',
            name: 'stock',
            component: () =>
                import ('@/views/Stock.vue'),
            meta: {
                pageTitle: 'Stock',
                breadcrumb: [{
                    text: 'Stock',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/etiquetas',
            name: 'etiquetas',
            component: () =>
                import ('@/views/Etiquetas.vue'),
            meta: {
                pageTitle: 'Etiquetas',
                breadcrumb: [{
                    text: 'Etiquetas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/etiquetas/disenador',
            name: 'etiquetas-disenador',
            component: () =>
                import ('@/views/EtiquetasDisenador.vue'),
            meta: {
                pageTitle: 'Diseñador de etiquetas',
                breadcrumb: [{
                    text: 'Diseñador',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/escaner',
            name: 'escaner',
            component: () =>
                import ('@/views/Escaner.vue'),
            meta: {
                pageTitle: 'Escáner de pedido',
                breadcrumb: [{
                    text: 'Escáner',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/escaner/pedidos',
            name: 'escaner-pedidos',
            component: () =>
                import ('@/views/EscanerPedidos.vue'),
            meta: {
                pageTitle: 'Pedidos del escáner',
                breadcrumb: [{
                    text: 'Pedidos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/escaner/pedidos/:id/confirmation',
            name: 'escaner-confirmacion',
            component: () =>
                import ('@/views/EscanerConfirmacion.vue'),
            meta: {
                pageTitle: 'Confirmation invoice',
                breadcrumb: [{
                    text: 'Pedidos',
                    to: '/escaner/pedidos',
                }, {
                    text: 'Confirmation invoice',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/statements',
            name: 'statements',
            component: () =>
                import ('@/views/Statements.vue'),
            meta: {
                pageTitle: 'Statements',
                breadcrumb: [{
                    text: 'Statements',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/wholesale/catalogo',
            name: 'wholesale-catalogo',
            component: () =>
                import ('@/views/WholesaleCatalogo.vue'),
            meta: {
                pageTitle: 'Catálogo web B2B',
                breadcrumb: [{
                    text: 'Catálogo web B2B',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/patrones',
            name: 'patrones',
            component: () =>
                import ('@/views/Patrones.vue'),
            meta: {
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/calculadora',
            name: 'calculadora',
            component: () =>
                import ('@/views/Calculadora.vue'),
            meta: {
                pageTitle: 'calculadora',
                breadcrumb: [{
                    text: 'calculadora',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/tiempos',
            name: 'tiempos',
            component: () =>
                import ('@/views/SkuTiempos.vue'),
            meta: {
                pageTitle: 'tiempos',
                breadcrumb: [{
                    text: 'tiempos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/report',
            name: 'report',
            component: () =>
                import ('@/views/Report.vue'),
            meta: {
                pageTitle: 'report',
                breadcrumb: [{
                    text: 'report',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/medidas',
            name: 'medidas',
            component: () =>
                import ('@/views/Medidas.vue'),
            meta: {
                pageTitle: 'medidas',
                breadcrumb: [{
                    text: 'medidas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/guia-corte',
            name: 'guia-corte',
            component: () =>
                import ('@/views/taller/GuiaCorte.vue'),
            meta: {
                pageTitle: 'Guia Corte',
                breadcrumb: [{
                    text: 'Guia Corte',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/guia-mano',
            name: 'guia-mano',
            component: () =>
                import ('@/views/taller/GuiaMano.vue'),
            meta: {
                pageTitle: 'Guia Mano',
                breadcrumb: [{
                    text: 'Guia Mano',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/guia-preparado',
            name: 'guia-preparado',
            component: () =>
                import ('@/views/taller/GuiaPreparado.vue'),
            meta: {
                pageTitle: 'Guia Preparado',
                breadcrumb: [{
                    text: 'Guia Preparado',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/guia-mano-medidas',
            name: 'guia-mano-medidas',
            component: () =>
                import ('@/views/taller/master/ConfeccionStyle.vue'),
            meta: {
                pageTitle: 'Guia Mano',
                breadcrumb: [{
                    text: 'Guia Mano',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/vista-previa-mano/:id?',
            name: 'vista-previa-mano',
            component: () =>
                import ('@/views/taller/VistaPreviaConfecion.vue'),
            meta: {
                pageTitle: 'Vista Previa Mano',
                breadcrumb: [{
                    text: 'Vista Previa Mano',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/sku-master',
            name: 'sku-master',
            component: () =>
                import ('@/views/taller/SkuMaster.vue'),
            meta: {
                pageTitle: 'SkuMaster',
                breadcrumb: [{
                    text: 'SkuMaster',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/sku-titulo',
            name: 'sku-titulo',
            component: () =>
                import ('@/views/taller/SkuTitulo.vue'),
            meta: {
                pageTitle: 'SkuTitulo',
                breadcrumb: [{
                    text: 'SkuTitulo',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/sku-semanas-produccion',
            name: 'sku-semanas-produccion',
            component: () =>
                import ('@/views/taller/SkuSemanasProduccion.vue'),
            meta: {
                pageTitle: 'SkuSemanasProduccion',
                breadcrumb: [{
                    text: 'SkuSemanasProduccion',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedidos',
            name: 'pedidos',
            component: () =>
                import ('@/views/taller/Pedidos.vue'),
            meta: {
                pageTitle: 'Pedidos',
                breadcrumb: [{
                    text: 'Pedidos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/gestionar',
            name: 'gestionar',
            component: () =>
                import ('@/views/taller/Gestionar.vue'),
            meta: {
                pageTitle: 'Gestionar',
                breadcrumb: [{
                    text: 'Gestionar',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pruebas',
            name: 'pruebas',
            component: () =>
                import ('@/views/taller/Pruebas.vue'),
            meta: {
                layout: 'full',
            },
        },
        {
            path: '/corte',
            name: 'corte',
            component: () =>
                import ('@/views/taller/trabajo/Corte.vue'),
            meta: {
                pageTitle: 'Corte',
                breadcrumb: [{
                    text: 'Corte',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/preparado',
            name: 'preparado',
            component: () =>
                import ('@/views/taller/trabajo/Preparacion.vue'),
            meta: {
                pageTitle: 'Preparado',
                breadcrumb: [{
                    text: 'Preparado',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/confeccion',
            name: 'confeccion',
            component: () =>
                import ('@/views/taller/trabajo/Confeccion.vue'),
            meta: {
                pageTitle: 'Confeccion',
                breadcrumb: [{
                    text: 'Confeccion',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/master-corte',
            name: 'master-corte',
            component: () =>
                import ('@/views/taller/master/Corte.vue'),
            meta: {
                pageTitle: 'Corte',
                breadcrumb: [{
                    text: 'Corte',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/master-confeccion',
            name: 'master-confeccion',
            component: () =>
                import ('@/views/taller/master/Confeccion.vue'),
            meta: {
                pageTitle: 'Confeccion',
                breadcrumb: [{
                    text: 'Confeccion',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/master-fabricacion',
            name: 'master-fabricacion',
            component: () =>
                import ('@/views/taller/master/Fabricacion.vue'),
            meta: {
                pageTitle: 'Fabricacion',
                breadcrumb: [{
                    text: 'Fabricacion',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/reportes',
            name: 'reportes',
            component: () =>
                import ('@/views/taller/Reportes.vue'),
            meta: {
                pageTitle: 'Reportes',
                breadcrumb: [{
                    text: 'Reportes',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/albaranV2',
            name: 'albaranV2',
            component: () =>
                import ('@/views/finanzas/AlbaranV2.vue'),
            meta: {
                pageTitle: 'AlbaranV2',
                breadcrumb: [{
                    text: 'AlbaranV2',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/albaran',
            name: 'albaran',
            component: () =>
                import ('@/views/finanzas/Albaran.vue'),
            meta: {
                pageTitle: 'Albaran',
                breadcrumb: [{
                    text: 'Albaran',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/kpi',
            name: 'kpi',
            component: () =>
                import ('@/views/finanzas/Kpi.vue'),
            meta: {
                pageTitle: 'Kpi',
                breadcrumb: [{
                    text: 'Kpi',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/kpi-gastos',
            name: 'kpi-gastos',
            component: () =>
                import ('@/views/finanzas/KpiGastos.vue'),
            meta: {
                pageTitle: 'KpiGastos',
                breadcrumb: [{
                    text: 'KpiGastos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/kpi-gastos-rules',
            name: 'kpi-gastos-rules',
            component: () =>
                import ('@/views/finanzas/kpiRules.vue'),
            meta: {
                pageTitle: 'KpiRules',
                breadcrumb: [{
                    text: 'KpiRules',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/bancos',
            name: 'bancos',
            component: () =>
                import ('@/views/finanzas/Bancos.vue'),
            meta: {
                pageTitle: 'Bancos',
                breadcrumb: [{
                    text: 'Bancos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/precios-sku',
            name: 'precios-sku',
            component: () =>
                import ('@/views/finanzas/PrecioSku.vue'),
            meta: {
                pageTitle: 'precioSku',
                breadcrumb: [{
                    text: 'precioSku',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/factura',
            name: 'factura',
            component: () =>
                import ('@/views/finanzas/Factura.vue'),
            meta: {
                pageTitle: 'Factura',
                breadcrumb: [{
                    text: 'Factura',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/gastos-proveedor',
            name: 'gastos-proveedor',
            component: () =>
                import ('@/views/finanzas/GastosProveedor.vue'),
            meta: {
                pageTitle: 'GastosProveedor',
                breadcrumb: [{
                    text: 'GastosProveedor',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/gastos-proveedor-v2',
            name: 'gastos-proveedor-v2',
            component: () =>
                import ('@/views/finanzas/GastosProveedorV2.vue'),
            meta: {
                pageTitle: 'Gastos Proveedor V2',
                breadcrumb: [{
                    text: 'Gastos Proveedor V2',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/fedex',
            name: 'fedex',
            component: () =>
                import ('@/views/finanzas/Fedex.vue'),
            meta: {
                pageTitle: 'Fedex',
                breadcrumb: [{
                    text: 'Fedex',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/ups',
            name: 'ups',
            component: () =>
                import ('@/views/finanzas/Ups.vue'),
            meta: {
                pageTitle: 'Ups',
                breadcrumb: [{
                    text: 'Ups',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/ups-facturas',
            name: 'ups-facturas',
            component: () =>
                import ('@/views/finanzas/UpsFacturas.vue'),
            meta: {
                pageTitle: 'UPS Facturas',
                breadcrumb: [{
                    text: 'UPS Facturas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/corporation-tax',
            name: 'corporation-tax',
            component: () =>
                import ('@/views/finanzas/CorporationTax.vue'),
            meta: {
                pageTitle: 'Corportation Tax',
                breadcrumb: [{
                    text: 'Corportation Tax',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/ean-list',
            name: 'ean-list',
            component: () =>
                import ('@/views/finanzas/ListaEan.vue'),
            meta: {
                pageTitle: 'Ean List',
                breadcrumb: [{
                    text: 'Ean List',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/ean-duplicados',
            name: 'ean-duplicados',
            component: () =>
                import ('@/views/finanzas/ListaEanDuplicados.vue'),
            meta: {
                pageTitle: 'Ean duplicados',
                breadcrumb: [{
                    text: 'Ean duplicados',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/sku-list',
            name: 'sku-list',
            component: () =>
                import ('@/views/finanzas/ListaSku.vue'),
            meta: {
                pageTitle: 'Sku List',
                breadcrumb: [{
                    text: 'Sku List',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedido-materiales',
            name: 'pedido-materiales',
            component: () =>
                import ('@/views/pedidos/Listado.vue'),
            meta: {
                pageTitle: 'Pedidos',
                breadcrumb: [{
                    text: 'Pedidos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/nuevo-pedido-materiales',
            name: 'nuevo-pedido-materiales',
            component: () =>
                import ('@/views/pedidos/Pedidos.vue'),
            meta: {
                pageTitle: 'Pedidos',
                breadcrumb: [{
                    text: 'Pedidos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedido-taller-vero',
            name: 'pedido-taller-vero',
            component: () =>
                import ('@/views/pedidosVero/Listado.vue'),
            meta: {
                pageTitle: 'Pedidos Vero',
                tipo: 'B2C',
                breadcrumb: [{
                    text: 'Pedidos Vero',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
         {
            path: '/pedido-taller-vero/nuevo',
            name: 'pedido-taller-vero/nuevo',
            component: () =>
                import ('@/views/pedidosVero/Nuevo.vue'),
            meta: {
                pageTitle: 'Pedidos Vero Nuevo',
                tipo: 'B2C',
                breadcrumb: [{
                    text: 'Pedidos Vero Nuevo',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedido-taller-vero-b2b',
            name: 'pedido-taller-vero-b2b',
            component: () =>
                import ('@/views/pedidosVero/Listado.vue'),
            meta: {
                pageTitle: 'Pedidos Vero B2B',
                tipo: 'B2B',
                breadcrumb: [{
                    text: 'Pedidos Vero B2B',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
         {
            path: '/pedido-taller-vero-b2b/nuevo',
            name: 'pedido-taller-vero-b2b/nuevo',
            component: () =>
                import ('@/views/pedidosVero/Nuevo.vue'),
            meta: {
                pageTitle: 'Pedidos Vero B2B Nuevo',
                tipo: 'B2B',
                breadcrumb: [{
                    text: 'Pedidos Vero B2B Nuevo',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedido-taller-vero/progreso',
            name: 'pedido-taller-vero-progreso',
            component: () =>
                import ('@/views/pedidosVero/ProgresoTaller.vue'),
            meta: {
                pageTitle: 'Progreso Taller',
                breadcrumb: [{
                    text: 'Progreso Taller',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedido-taller-vero/fabricando',
            name: 'pedido-taller-vero-fabricando',
            component: () =>
                import ('@/views/pedidosVero/Fabricando.vue'),
            meta: {
                pageTitle: 'En Produccion',
                breadcrumb: [{
                    text: 'En Produccion',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },       
        {
            path: '/pedido-taller-vero/progreso-corte',
            name: 'pedido-taller-vero-progreso-corte',
            component: () =>
                import ('@/views/pedidosVero/ProgresoCorte.vue'),
            meta: {
                pageTitle: 'Progreso Corte',
                breadcrumb: [{
                    text: 'Progreso Corte',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/pedido-taller-vero/progreso-mano',
            name: 'pedido-taller-vero-progreso-mano',
            component: () =>
                import ('@/views/pedidosVero/ProgresoMano.vue'),
            meta: {
                pageTitle: 'Progreso Aparado',
                breadcrumb: [{
                    text: 'Progreso Aparado',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/factura-edit',
            name: 'factura-edit',
            component: () =>
                import ('@/views/finanzas/FacturaEdit.vue'),
            meta: {
                pageTitle: 'Factura Edit',
                breadcrumb: [{
                    text: 'Factura Edit',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/factura-edit/:parametro',
            name: 'factura-edit-param',
            component: () =>
                import ('@/views/finanzas/FacturaEdit.vue'),
            meta: {
                pageTitle: 'Factura Edit',
                breadcrumb: [{
                    text: 'Factura Edit',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/factura-preview/:id',
            name: 'factura-preview',
            component: () =>
                import ('@/views/finanzas/FacturaPreview.vue'),
            meta: {
                pageTitle: 'Factura Preview',
                breadcrumb: [{
                    text: 'Factura Preview',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/map/:id?',
            name: 'map',
            component: () =>
                import ('@/views/marketing/Map.vue'),
            meta: {
                pageTitle: 'Map',
                breadcrumb: [{
                    text: 'Map',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/map-v2/:id?',
            name: 'map-v2',
            component: () =>
                import ('@/views/marketing/MapV2.vue'),
            meta: {
                pageTitle: 'Map v2',
                breadcrumb: [{
                    text: 'Map v2',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/automatizaciones-plataforma/:id?',
            name: 'automatizaciones-plataforma',
            component: () =>
                import ('@/views/marketing/AutomatizacionesPlataformas.vue'),
            meta: {
                pageTitle: 'automatizaciones-plataforma',
                breadcrumb: [{
                    text: 'automatizaciones-plataforma',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/gestion-influencers',
            name: 'gestion-influencers',
            component: () =>
                import ('@/views/marketing/GestionInfluencers.vue'),
            meta: {
                pageTitle: 'gestion-influencers',
                breadcrumb: [{
                    text: 'gestion-influencers',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/gestion-plantillas',
            name: 'gestion-plantillas',
            component: () =>
                import ('@/views/marketing/GestionPlantillasEmail.vue'),
            meta: {
                pageTitle: 'gestion-plantillas',
                breadcrumb: [{
                    text: 'gestion-plantillas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/sku-amazon',
            name: 'sku-amazon',
            component: () =>
                import ('@/views/produccion/skuAmazon.vue'),
            meta: {
                pageTitle: 'sku-amazon',
                breadcrumb: [{
                    text: 'sku-amazon',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/amazon-shopify',
            name: 'amazon-shopify',
            component: () =>
                import ('@/views/produccion/amazon-shopify.vue'),
            meta: {
                pageTitle: 'amazon-shopify',
                breadcrumb: [{
                    text: 'amazon-shopify',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/shopify-invoice-pdf',
            name: 'shopify-invoice-pdf',
            component: () =>
                import ('@/views/shopify/InvoicePdf.vue'),
            meta: {
                pageTitle: 'Factura Shopify PDF',
                breadcrumb: [{
                    text: 'Factura Shopify PDF',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/amazon-productos',
            name: 'amazon-productos',
            component: () =>
                import ('@/views/produccion/AmazonProductos.vue'),
            meta: {
                pageTitle: 'Amazon Productos',
                breadcrumb: [{
                    text: 'Amazon Productos',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/gestion-usuarios',
            name: 'gestion-usuarios',
            component: () =>
                import ('@/views/GestionUsuarios.vue'),
            meta: {
                pageTitle: 'Usuarios',
                breadcrumb: [{
                    text: 'Usuarios',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/ia-gmail',
            name: 'ia-gmail',
            component: () =>
                import ('@/views/ia/gmail/Email.vue'),
            meta: {
                pageTitle: 'Gmail',
                breadcrumb: [{
                    text: 'Gmail',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },{
            path: '/ia-gmail-plantillas',
            name: 'ia-gmail-plantillas',
            component: () =>
                import ('@/views/ia/gmail/EmailPlantillas.vue'),
            meta: {
                pageTitle: 'Gmail Plantillas',
                breadcrumb: [{
                    text: 'Gmail Plantillas',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/ia-gmail-v2',
            name: 'ia-gmail-v2',
            component: () =>
                import ('@/views/ia/gmail/EmailManager.vue'),
            meta: {
                pageTitle: 'Gmail V2',
                breadcrumb: [{
                    text: 'Gmail V2',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/fichaje',
            name: 'fichaje',
            component: () =>
                import ('@/views/Fichaje.vue'),
            meta: {
                pageTitle: 'Fichaje',
                breadcrumb: [{
                    text: 'Fichaje',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/fichaje-admin',
            name: 'fichaje-admin',
            component: () =>
                import ('@/views/FichajeAdmin.vue'),
            meta: {
                pageTitle: 'Fichaje Admin',
                breadcrumb: [{
                    text: 'Fichaje Admin',
                    active: true,
                }, ],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/login',
            name: 'auth-login',
            component: () =>
                import ('@/views/Login.vue'),
            //import ('@/views/taller/Pruebas.vue'),
            meta: {
                layout: 'full',
            },
        },
        // =============================================
        // AVISOS
        // =============================================
        {
            path: '/avisos',
            name: 'avisos',
            component: () =>
                import ('@/views/avisos/Index.vue'),
            meta: {
                pageTitle: 'Avisos',
                breadcrumb: [{
                    text: 'Avisos',
                    active: true,
                }],
                redirectIfLoggedIn: true,
            },
        },
        // =============================================
        // VACACIONES
        // =============================================
        {
            path: '/vacaciones',
            name: 'vacaciones-mi-calendario',
            component: () =>
                import ('@/views/vacaciones/MiCalendario.vue'),
            meta: {
                pageTitle: 'Mis Vacaciones',
                breadcrumb: [{
                    text: 'Vacaciones',
                    active: true,
                }],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/vacaciones/admin',
            name: 'vacaciones-admin',
            component: () =>
                import ('@/views/vacaciones/admin/Index.vue'),
            meta: {
                pageTitle: 'Admin Vacaciones',
                breadcrumb: [{
                    text: 'Vacaciones',
                    to: '/vacaciones',
                }, {
                    text: 'Administracion',
                    active: true,
                }],
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/app-usos',
            name: 'app-usos',
            component: () =>
                import ('@/views/AppUsos.vue'),
            meta: {
                layout: 'full',
            },
        },
        {
            path: '/json',
            name: 'json-viewer',
            component: () =>
                import ('@/views/JsonViewer.vue'),
            meta: {
                layout: 'full',
                redirectIfLoggedIn: true,
            },
        },
        {
            path: '/error-404',
            name: 'error-404',
            component: () =>
                import ('@/views/error/Error404.vue'),
            meta: {
                layout: 'full',
            },
        },
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

router.beforeEach((to, _, next) => {
    const isLoggedIn = isUserLoggedIn()

    if (to.name == "auth-login")
        return next()

    if (!canNavigate(to)) {

        // Redirect to login if not logged in
        if (!isLoggedIn) return next({ path: '/login' })
    }

    // Redirect if logged in
    /*if (to.meta.redirectIfLoggedIn && isLoggedIn) {
        console.log("its login");
        const userData = getUserData()
        next({ name: '/' })
    }*/

    return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

// Tras un deploy, los chunks con hash antiguo dejan de existir en el servidor.
// Las pestañas ya abiertas fallan al cargar la ruta (ChunkLoadError / "Unexpected token '<'").
// Detectamos ese error y recargamos la página una sola vez para coger la versión nueva.
router.onError(error => {
    const message = (error && error.message) || ''
    const isChunkError =
        /Loading( CSS)? chunk [\d\w]+ failed/i.test(message) ||
        /ChunkLoadError/i.test((error && error.name) || '') ||
        /Unexpected token '<'/i.test(message)

    if (!isChunkError) return

    // Guard contra bucles de recarga: solo recargamos una vez por minuto.
    const KEY = 'chunk-reload-ts'
    const last = Number(sessionStorage.getItem(KEY) || 0)
    const now = Date.now()
    if (now - last < 60000) {
        console.error('ChunkLoadError persistente tras recargar:', error)
        return
    }
    sessionStorage.setItem(KEY, String(now))

    // Recargamos en la ruta destino para que el usuario acabe donde quería ir.
    const target = (router.history && router.history.pending && router.history.pending.fullPath) ||
        window.location.pathname + window.location.search
    window.location.assign(target)
})

export default router
